"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validatePricingPeriod = exports.datesOverlap = void 0;
const diem_1 = __importDefault(require("@travelnest/diem"));
const validators_1 = require("./validators");
// Inclusive (true if days are same)
const isBefore = (a, b) => a.diff(b) <= 0;
// Inclusive (true if days are same)
const isAfter = (a, b) => a.diff(b) >= 0;
/**
 * Determine whether a pair of dates "a" have any overlap with a pair of dates "b".
 * @param {DatePair} a - the dates to check with
 * @param {DatePair} b - the dates to test for overlap
 *
 * @returns {boolean} overlaps - Whether the dates have any overlap
 */
const datesOverlap = (a, b) => {
    // Full overlap, a contains b
    if (isBefore(a.start, b.start) && isAfter(a.end, b.end)) {
        return true;
    }
    // "Left-hand" overlap - a.start is within b's DatePair
    if (isAfter(a.start, b.start) && isBefore(a.start, b.end)) {
        return true;
    }
    // "Right-hand" overlap - a.end is within b's DatePair
    if (isAfter(a.end, b.start) && isBefore(a.end, b.end)) {
        return true;
    }
    return false;
};
exports.datesOverlap = datesOverlap;
/**
 * Validate a pricing period.
 * @param {IPricingUi} period - The pricing period to validate
 * @param {IPricingUi[]} otherPricing - The rest of the property's pricing (MUST NOT contain `period`)
 *
 * @returns {IPricingPeriodValidation} validation - The period's validation
 */
const validatePricingPeriod = (period, otherPricing) => {
    const validation = { allValid: false, name: {}, prices: {}, dates: {} };
    const nameValid = (0, validators_1.stringPresent)(period.name);
    validation.name = {
        valid: nameValid,
        errorMessage: nameValid ? undefined : 'You must provide a pricing period name'
    };
    validation.prices = Object.keys(period.prices).reduce((acc, day) => {
        const priceValue = period.prices[day];
        const priceValid = typeof priceValue === 'number' && priceValue > 0;
        return Object.assign(Object.assign({}, acc), { [day]: {
                valid: priceValid
            } });
    }, {});
    if (new diem_1.default(period.start_date).diff(new diem_1.default(period.end_date)) >= 0) {
        validation.dates = { valid: false, errorMessage: 'Start date must be before end date' };
    }
    else { // Check for overlaps
        const overlaps = otherPricing.filter((op) => (0, exports.datesOverlap)({ start: new diem_1.default(period.start_date), end: new diem_1.default(period.end_date) }, { start: new diem_1.default(op.start_date), end: new diem_1.default(op.end_date) }));
        const datesValid = overlaps.length === 0;
        validation.dates = { valid: datesValid, errorMessage: datesValid ? undefined : `These dates would modify ${overlaps.length} pricing period${overlaps.length === 1 ? '' : 's'}` };
    }
    validation.allValid = validation.name.valid &&
        validation.dates.valid &&
        Object.keys(validation.prices).every((k) => validation.prices[k].valid);
    return validation;
};
exports.validatePricingPeriod = validatePricingPeriod;
//# sourceMappingURL=pricingPeriods.js.map